'use client';

import {
  LocaleLink,
  Separator,
  StarIcon,
  TypographyMuted,
  TypographyStrong,
} from '@/components';
import { useProductValue } from '@/context';
import { PATHNAME } from '@/utils';

const {
  DEFAULT: { SLUG_SEPARATOR: DEFAULT_SLUG_SEPARATOR },
  LOCAL: {
    CATEGORY: { BASE_URL: CATEGORY_BASE_URL },
    BRANDS: { BASE_URL: BRANDS_PAGE_URL },
  },
} = PATHNAME;

const ProductSummaryCategory = () => {
  const { mainCategory } = useProductValue();

  if (mainCategory) {
    return (
      <div className='flex flex-wrap items-center gap-0.5'>
        <TypographyMuted>دسته بندی:</TypographyMuted>
        <TypographyStrong className='text-sm font-medium text-primary'>
          <LocaleLink
            href={`${CATEGORY_BASE_URL}${mainCategory.slug}${DEFAULT_SLUG_SEPARATOR}`}
          >
            {mainCategory.title}
          </LocaleLink>
        </TypographyStrong>
      </div>
    );
  }
};

const ProductSummaryBrand = () => {
  const { brand } = useProductValue();

  if (brand) {
    return (
      <div className='flex flex-wrap items-center gap-0.5'>
        <TypographyMuted>برند:</TypographyMuted>
        <TypographyStrong className='text-sm font-medium text-primary'>
          <LocaleLink
            href={`${BRANDS_PAGE_URL}${brand.slug}${DEFAULT_SLUG_SEPARATOR}`}
          >
            {brand.title}
          </LocaleLink>
        </TypographyStrong>
      </div>
    );
  }
};

const ProductSummaryComment = () => {
  const { calculatedComments } = useProductValue();

  const { total, rate } = calculatedComments ?? {};

  if (total) {
    return (
      <div className='flex flex-wrap items-center gap-2'>
        <StarIcon fill='gold' stroke='gold' />
        <TypographyMuted>
          <span>5 / {rate}</span>
        </TypographyMuted>
        <Separator orientation='vertical' className='h-4' />
        <TypographyMuted>{total} دیدگاه</TypographyMuted>
      </div>
    );
  }
};

const ProductSummary = () => (
  <div className='flex flex-wrap items-center justify-between gap-y-2'>
    <div className='flex gap-5'>
      <ProductSummaryCategory />
      <ProductSummaryBrand />
    </div>
    <ProductSummaryComment />
  </div>
);

export { ProductSummary };
